













































































































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers } from '@/mixins';
import { BaseResultModel, ScriveTemplateSigningPartyConfigurationModel, Configuration, Dictionary, ScriveTemplateSigningPartyModel, ScriveTemplateSigningPartyCreateUpdateModel } from '@/types';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';

export default Vue.extend({
  name: 'ScriveAddSigningParty',
  mixins: [FormFieldValidation, RouteHelpers],
  data() {
    return {
      isLoading: true,
      templateSigningParty: {} as ScriveTemplateSigningPartyModel,
      templateSigningPartyConfiguration: {} as ScriveTemplateSigningPartyConfigurationModel,
      submitIsLoading: false,
      saveAndAddFieldSubmitting: false,
      templateSigningPartyId: null,
      hasError: false,
      errorMessage: '',
      navigateFunction: (): void => {
        console.log('The field navigateFunction is not implemented');
      }
    };
  },
  methods: {
    async onSubmit(this: any, setSubmittingState: (state: boolean) => void) {
      this.resetFormValidation();
      try {
        if (this.validateSignerRole()) {
          setSubmittingState(true);

          const result: BaseResultModel = await ScriveConfigurationService.createSigningPartyAsync({
            documentTypeId: this.documentTypeId,
            templateId: this.templateId,
            signerRoleId: this.templateSigningParty.signerRoleId,
            description: this.templateSigningParty.description
          } as ScriveTemplateSigningPartyCreateUpdateModel);

          if (result.hasNotification && !result.showToast) {
            this.addFormValidationError(result.notification);
            setSubmittingState(false);
            return;
          }

          this.templateSigningPartyId = result.id;

          SnotifyConfiguration.showSuccess('Signing Party created successfully.');
          this.setApplicationDirty(false);
          this.navigateFunction();
        }
      } catch (error) {
        this.$log('Error creating signing party', error);
      } finally {
        setSubmittingState(false);
      }
    },
    async getDataAsync(this: any) {
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        this.templateSigningPartyConfiguration = await ScriveConfigurationService.getTemplateSigningPartyConfigurationAsync({
          documentTypeId: this.documentTypeId,
          templateSigningPartyId: null
        });
      } catch (error) {
        this.$log('Error getting signing party');
      } finally {
        this.isLoading = false;
      }
    },
    onCancel(this: any) {
      this.navigateToEditTemplate();
    },
    navigateToEditTemplate(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.id = this.templateId;

      this.$router.push({
        name: Configuration.Scrive.Template.Edit.name,
        params: param
      });
    },
    navigateToAddSigningPartyField(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      param.signingPartyId = this.templateSigningPartyId;
      this.$router.push({
        name: Configuration.Scrive.SigningPartyField.Add.name,
        params: param
      });
    },
    setSaveSubmittingState(this: any, state: boolean) {
      this.submitIsLoading = state;
    },
    setSaveAndAddFieldSubmittingState(this: any, state: boolean) {
      this.saveAndAddFieldSubmitting = state;
    },
    validateSignerRole(this: any): boolean {
      this.resetFormValidation();
      if (this.templateSigningParty.signerRoleId == null || this.templateSigningParty.signerRoleId < 1) {
        this.addFormValidationError('Please select a Signer');
        return false;
      }
      return true;
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    }
  },
  mounted(this: any) {
    this.getDataAsync();
  },
  components: {
    LoadingSpinner,
    MStoreFormSelect,
    MStoreSpinnerButton
  }
});
